import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { ContentPromotionForm } from "@/types/models";
import { District } from "@/types/models/District.interface";
import { School } from "@/types/models/School.interface";

interface ParamsToRetrieveContentPromotionConfigurationForms {
  districtUniqueId?: District["unique_id"] | null;
  schoolUniqueId?: School["unique_id"] | null;
}

const useLazyContentPromotionFormsGet = (
  data: ParamsToRetrieveContentPromotionConfigurationForms,
) => {
  let queryParamForVenue;
  const { districtUniqueId, schoolUniqueId } = data;
  if (districtUniqueId) {
    queryParamForVenue = `district_id=${districtUniqueId}`;
  } else if (schoolUniqueId) {
    queryParamForVenue = `school_id=${schoolUniqueId}`;
  }

  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/platform-alignment-form/?${queryParamForVenue}`;

  return useLazyRestQuery(requestUrl, {
    skip: !districtUniqueId && !schoolUniqueId,
  }) as [
    () => void,
    {
      data: ContentPromotionForm[] | undefined;
      error: Error;
      loading: boolean;
    },
  ];
};

export default useLazyContentPromotionFormsGet;
